/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDetailsPage} from '../api'

 export const useQueryGetDetailsPage = createReactQueryHook('getDetailsPage', getDetailsPage)
